<template>
  <div class="nb-lock-page">
    <section
      class="right"
     
    >
        <!-- 查询条件 -->
        <div class="searchbox">
          <form action="#" method="get" class="form-inline form-float" @submit.prevent="handleSearch">
         
              <div class="form-group">
                <search-parking ref="searchParking"></search-parking>
              </div>
              <div class="form-group">
                <input
                  v-model.trim="search.lockCode"
                  class="form-control"
                  type="text"
                  placeholder="请输入锁编号"
                  size="12"
                  @keyup.enter="handleSearch"
                />
              </div>
              <div class="form-group">
                <input
                  v-model.trim="search.spaceNum"
                  class="form-control"
                  type="text"
                  placeholder="请输入车位号"
                  size="12"
                  @keyup.enter="handleSearch"
                />
              </div>
              <div class="form-group">
                <el-select v-model="search.onlineStatus" placeholder="请选择设备状态" clearable>
                  <el-option label="在线" value="在线"></el-option>
                  <el-option label="离线" value="离线"></el-option>
                </el-select>
              </div>
              <div class="form-group">
                <el-select v-model="search.parkingSpaceStatus" placeholder="请选择车位状态" clearable>
                  <el-option label="未知" value="未知"></el-option>
                  <el-option label="有车" value="有车"></el-option>
                  <el-option label="无车" value="无车"></el-option>
                </el-select>
              </div>
              <div class="form-group">
                <el-select v-model="search.baffleStatus" placeholder="请选择挡板状态" clearable>
                  <el-option label="未知" value="未知"></el-option>
                  <el-option label="正常升起" value="正常升起"></el-option>
                  <el-option label="正常降落" value="正常降落"></el-option>
                  <el-option label="升板异常" value="升板异常"></el-option>
                  <el-option label="降板异常" value="降板异常"></el-option>
                  <el-option label="重复升锁后正常" value="重复升锁后正常"></el-option>
                  <el-option label="重复降锁后正常" value="重复降锁后正常"></el-option>
                </el-select>
              </div>
              <div class="form-group">
                <el-select v-model="search.bindStatus" placeholder="设备绑定情况" clearable>
                  <el-option label="已绑定" value="已绑定"></el-option>
                  <el-option label="未绑定" value="未绑定"></el-option>
                </el-select>
              </div>
              <div class="form-group">
                <el-select v-model="search.isFlooded" placeholder="请选择是否水淹" clearable>
                  <el-option label="正常" value="正常"></el-option>
                  <el-option label="水淹" value="水淹"></el-option>
                </el-select>
              </div>
              <div class="form-group">
                <el-select v-model="search.power" placeholder="请选择电量" clearable>
                  <el-option label="0%" value="0"></el-option>
                  <el-option label="10%" value="10"></el-option>
                  <el-option label="20%" value="20"></el-option>
                  <el-option label="30%" value="30"></el-option>
                  <el-option label="40%" value="40"></el-option>
                  <el-option label="50%" value="50"></el-option>
                  <el-option label="60%" value="60"></el-option>
                  <el-option label="70%" value="70"></el-option>
                  <el-option label="80%" value="80"></el-option>
                  <el-option label="90%" value="90"></el-option>
                  <el-option label="100%" value="100"></el-option>
                </el-select>
              </div>
          
            <!-- 第二排：常用操作按钮 -->
            <div class="search-row search-row-actions">
              <span class="search_btn">
                <button
                  type="submit"
                  class="btn btn-primary"
                  id="search_btn"
                  :disabled="queryLoading"
                >
                  <i v-if="queryLoading" class="el-icon-loading"></i>
                  {{ queryLoading ? "查询中..." : "查询" }}
                </button>
              </span>
              <span class="reset_btn">
                <button
                  type="button"
                  class="btn btn-default"
                  @click="handleReset"
                >
                  重置
                </button>
              </span>
            </div>
          </form>
        </div>
        
        <!-- 统计卡片 -->
        <div class="stats-cards">
          <div class="stats-card">
            <div class="stats-info">
              <div class="stats-title">总设备数量/离线数量/占比(%)</div>
              <div class="stats-value">
                <span class="stats-main">{{ stats.totalDevice }}</span>
                <span class="stats-separator">/</span>
                <span class="stats-main">{{ stats.offlineDevice }}</span>
                <span class="stats-separator">/</span>
                <span class="stats-sub">{{ stats.offlineRate }}%</span>
              </div>
            </div>
            <div class="stats-icon">
              <img src="@/assets/images/lock/total_device.png" alt="总设备" />
            </div>
          </div>
          <div class="stats-card">
            <div class="stats-info">
              <div class="stats-title">在线设备数量/占比(%)</div>
              <div class="stats-value">
                <span class="stats-main">{{ stats.onlineDevice }}</span>
                <span class="stats-separator">/</span>
                <span class="stats-sub">{{ stats.onlineRate }}%</span>
              </div>
            </div>
            <div class="stats-icon">
              <img src="@/assets/images/lock/online_device.png" alt="在线设备" />
            </div>
          </div>
          <div class="stats-card">
            <div class="stats-info">
              <div class="stats-title">水淹设备数量/占比(%)</div>
              <div class="stats-value">
                <span class="stats-main">{{ stats.floodDevice }}</span>
                <span class="stats-separator">/</span>
                <span class="stats-sub">{{ stats.floodRate }}%</span>
              </div>
            </div>
            <div class="stats-icon">
              <img src="@/assets/images/lock/flood_device.png" alt="水淹设备" />
            </div>
          </div>
          <div class="stats-card">
            <div class="stats-info">
              <div class="stats-title">电量过低设备数量/占比(%)</div>
              <div class="stats-value">
                <span class="stats-main">{{ stats.lowPowerDevice }}</span>
                <span class="stats-separator">/</span>
                <span class="stats-sub">{{ stats.lowPowerRate }}%</span>
              </div>
            </div>
            <div class="stats-icon">
              <img src="@/assets/images/lock/power_device.png" alt="电量过低" />
            </div>
          </div>
          <div class="stats-card">
            <div class="stats-info">
              <div class="stats-title">挡板异常设备数量/占比(%)</div>
              <div class="stats-value">
                <span class="stats-main">{{ stats.baffleAbnormal }}</span>
                <span class="stats-separator">/</span>
                <span class="stats-sub">{{ stats.baffleAbnormalRate }}%</span>
              </div>
            </div>
            <div class="stats-icon">
              <img src="@/assets/images/lock/baffle_abnormal.png" alt="挡板异常" />
            </div>
          </div>
          <div class="stats-card">
            <div class="stats-info">
              <div class="stats-title">挡板升起设备数量/占比(%)</div>
              <div class="stats-value">
                <span class="stats-main">{{ stats.baffleRising }}</span>
                <span class="stats-separator">/</span>
                <span class="stats-sub">{{ stats.baffleRisingRate }}%</span>
              </div>
            </div>
            <div class="stats-icon">
              <img src="@/assets/images/lock/baffle_rising.png" alt="挡板升起" />
            </div>
          </div>
        </div>

        <!-- 批量操作栏：统计卡片与列表之间 -->
        <div class="batch-actions-bar">
          <span class="add_btn">
            <button
              type="button"
              class="btn btn-default"
              id="addarea"
              @click="addOrEdit()"
            >
              新增
            </button>
          </span>
          <span class="add_btn">
            <button
              type="button"
              class="btn btn-default"
              @click="batchImport"
            >
              批量导入
            </button>
          </span>
          <span class="add_btn">
            <button
              type="button"
              class="btn btn-default"
              @click="download"
              :disabled="exportLoading"
            >
              <i v-if="exportLoading" class="el-icon-loading"></i>
              {{ exportLoading ? "导出中..." : "导出" }}
            </button>
          </span>
          <span class="add_btn">
            <button
              type="button"
              class="btn btn-batch-open"
              @click="batchOperate('open')"
              :disabled="!hasSelectedLocks"
            >
              批量升锁
            </button>
          </span>
          <span class="add_btn">
            <button
              type="button"
              class="btn btn-batch-close"
              @click="batchOperate('close')"
              :disabled="!hasSelectedLocks"
            >
              批量降锁
            </button>
          </span>
          <span class="add_btn">
            <button
              type="button"
              class="btn btn-batch-reset"
              @click="batchOperate('reset')"
              :disabled="!hasSelectedLocks"
            >
              批量复位
            </button>
          </span>
          <span class="add_btn">
            <button
              type="button"
              class="btn btn-batch-restart"
              @click="batchOperate('restart')"
              :disabled="!hasSelectedLocks"
            >
              批量重启
            </button>
          </span>
          <!-- <span class="add_btn" style="position: relative;">
            <button
              type="button"
              class="btn btn-default"
              @click="goToAlarmEvent"
            >
              告警事件
            </button>
            <span
              v-if="unprocessedAlarmCount > 0"
              class="alarm-badge"
            >
              {{ unprocessedAlarmCount > 99 ? '99+' : unprocessedAlarmCount }}
            </span>
          </span> -->
        </div>
        
        <!-- 列表区域 -->
        <div class="list-wrapper" v-loading="queryLoading" element-loading-text="数据加载中...">
          <List
            ref="listRef"
            v-if="isSelected === 'list'"
            :lockCode="search.lockCode"
            :spaceNum="search.spaceNum"
            :onlineStatus="search.onlineStatus"
            :parkingSpaceStatus="search.parkingSpaceStatus"
            :baffleStatus="search.baffleStatus"
            :bindStatus="search.bindStatus"
            :isFlooded="search.isFlooded"
            :power="search.power"
            :parkingId="parkingId"
            @selection-change="handleSelectionChange"
            @operation-complete="fetchStats"
          ></List>
          <div class="pagination-wrapper">
            <Page v-on:pagination="receivePaginationData" :absolute="false"></Page>
          </div>
        </div>
      
    </section>
    <!--批量添加地锁-->
    <el-dialog
      :close-on-click-modal="false"
      title="批量添加地锁"
      :visible.sync="batchImportDialogFormVisible"
      width="500px"
      @closed="closeUpload"
    >
      <div class="downloadTemplate">
        <span class="downloadButtonText">
          <span class="tip">*</span>请先
          <span @click="bulkLoadTemplate" class="downloadButton">下载模板</span
          >，按照模板要求填入数据后，再上传文件
        </span>
      </div>
      <div class="upload">
        <el-upload
          ref="upload"
          class="upload-demo"
          action="/prod-api/park/lock/importData"
          :multiple="false"
          name="uploadFile"
          accept="MultipartFile"
          :limit="1"
          :auto-upload="false"
          :on-success="fileSuccess"
          :on-error="fileError"
        >
          <span>上传文件:</span>
          <el-button size="small" type="primary" class="uploadButton"
            >点击上传</el-button
          >
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitUpload" size="small"
          >确 定</el-button
        >
        <el-button @click="batchImportDialogFormVisible = false" size="small"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    
    <!-- 运营模式设置对话框 -->
    <el-dialog
      title="运营模式设置"
      :visible.sync="operationModeDialogVisible"
      width="600px"
      :close-on-click-modal="false"
    >
      <el-form :model="operationModeForm" label-width="120px">
        <el-form-item label="运营模式">
          <el-select v-model="operationModeForm.mode" placeholder="请选择运营模式" style="width: 100%;">
            <el-option label="常降模式" value="常降模式"></el-option>
            <el-option label="人工模式" value="人工模式"></el-option>
            <el-option label="常升模式" value="常升模式"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模式说明">
          <div class="mode-description">
            <div  class="description-item">
              <strong>常降模式：</strong>无车时，车位锁挡板降下，有车时，挡板自动升起并开始计费，扫码支付后自动降锁驶离
            </div>
            <div  class="description-item">
              <strong>人工模式：</strong>车位锁挡板不进行自动升降，必须由运维人员或管理人员进行升降挡板
            </div>
            <div class="description-item">
              <strong>常升模式：</strong>无车时，挡板自动升起，需要停车时，只需要预约或者管理人员降锁后才能停车
            </div>
            <!-- <div v-if="!operationModeForm.mode" class="description-placeholder">
              请选择运营模式查看说明
            </div> -->
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="operationModeDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveOperationMode">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { addLock, equipWarn } from "@/api/url";
import SearchParking from "@/page/commons/searchParking";
import Page from "@/page/commons/page";
// import Chart from "./chart.vue";
import List from "./list.vue";
const LOCK_ALARM = {
  1: "打开",
  0: "关闭",
};
const LOCK_FORARM_BLOCK = {
  "00": "低",
  "01": "中",
  10: "高",
  11: "最高",
};
const LOCK_POWER = {
  "00": "低",
  "01": "中",
  10: "高",
  11: "最高",
};
const LOCK_TIME = {
  "000": "不自动升",
  "001": "2分钟",
  "010": "5分钟",
  "011": "15分钟",
  100: "30分钟",
  101: "60分钟",
};
const LOCK_HEARTBEAT = {
  "000": "1分钟",
  "001": "5分钟",
  "010": "10分钟",
  "011": "30分钟",
  100: "60分钟",
  101: "2小时",
  110: "3小时",
  111: "4小时",
};
export default {
  data() {
    return {
      queryLoading: false,
      exportLoading: false,
      batchImportDialogFormVisible: false,
      operationModeDialogVisible: false,
      isSelected: "list",
      search: {
        lockCode: "", // 锁编号
        spaceNum: "", // 车位号
        onlineStatus: "", // 设备状态
        parkingSpaceStatus: "", // 车位状态
        baffleStatus: "", // 挡板状态
        bindStatus: "", // 设备绑定情况，1:已绑定 0:未绑定
        isFlooded: "", // 是否水淹
        power: "", // 电量百分比(≥)
      },
      operationModeForm: {
        mode: "",
      },
      selectedLocksCount: 0, // 选中的车锁数量
      selectedLockCodes: [], // 选中的车锁编号列表
      unprocessedAlarmCount: 0, // 未处理的告警事件数量
      alarmCountTimer: null, // 定时器
      stats: {
        totalDevice: 0,
        offlineDevice: 0,
        offlineRate: 0,
        onlineDevice: 0,
        onlineRate: 0,
        floodDevice: 0,
        floodRate: 0,
        lowPowerDevice: 0,
        lowPowerRate: 0,
        baffleAbnormal: 0,
        baffleAbnormalRate: 0,
        baffleRising: 0,
        baffleRisingRate: 0,
      },
    };
  },
  components: {
    SearchParking,
    // Chart,
    List,
    Page,
  },
  computed: {
    ...mapState("parking", ["oneParking"]),
    // 检查是否有选中的车锁
    hasSelectedLocks() {
      return this.selectedLocksCount > 0;
    },
    // 当前选中的道路ID
    parkingId() {
      return this.oneParking ? this.oneParking.parkingId : "";
    },
  },
  methods: {
    ...mapMutations(["getPage"]),
    ...mapActions("parking", ["setParking"]),
    
    // 查询
    handleSearch() {
      if (this.queryLoading) return;
      this.queryLoading = true;
      if (this.$refs.listRef && typeof this.$refs.listRef.tableList === "function") {
        this.$refs.listRef.tableList(1).finally(() => {
          this.queryLoading = false;
        });
      } else {
        this.queryLoading = false;
      }
      // 刷新统计卡片
      this.fetchStats();
    },
    
    // 重置
    handleReset() {
      this.search.lockCode = "";
      this.search.spaceNum = "";
      this.search.onlineStatus = "";
      this.search.parkingSpaceStatus = "";
      this.search.baffleStatus = "";
      this.search.bindStatus = "";
      this.search.isFlooded = "";
      this.search.power = "";
      // 重置 search-parking 组件
      if (this.$refs.searchParking) {
        this.$refs.searchParking.id = "";
      }
      this.$store.dispatch("parking/setParking", null);
      // 重新查询
      this.$nextTick(() => {
        if (this.$refs.listRef && typeof this.$refs.listRef.tableList === "function") {
          this.$refs.listRef.tableList(1);
        }
        // 刷新统计卡片
        this.fetchStats();
      });
    },
    onSwitchClick(type) {
      this.isSelected = type;
    },
    addOrEdit(id) {
      // 调用子组件的添加/修改方法
      if (this.$refs.listRef) {
        this.$refs.listRef.addOrEdit(id);
      }
    },
    download() {
      if (this.exportLoading) return;
      this.exportLoading = true;
      this.$downloadFileRequest(
        "/prod-api/park/lock/export",
        {},
        "lora地锁"
      ).finally(() => {
        this.exportLoading = false;
      });
    },
    batchImport() {
      this.batchImportDialogFormVisible = true;
    },
    //批量上传
    submitUpload() {
      this.batchImportDialogFormVisible = false;

      this.$refs.upload.submit();
    },
    bulkLoadTemplate() {
      window.open("/prod-api/park/lock/importTemplate", "_self");
    },

    closeUpload() {
      this.$refs.upload.clearFiles();
    },
    fileSuccess(response, file, fileList) {
      var _this = this;
      this.search.pageNumber = 1;
      //   this.tableList(this.search.pageNumber);
      this.batchImportResultDialogFormVisible = true;
      let span = document.createElement("span");
      this.$nextTick(function () {
        _this.$refs.showBatchImportResult.innerHTML = "";
        span.innerHTML = response.data;
        _this.$refs.showBatchImportResult.appendChild(span);
      });
    },
    fileError(err, file, fileList) {
      // console.log(err)
    },
    onTaskClick(){
        this.$router.push({path:'/main/equipment/lora-lock/task'})
    },
    // 处理选择变化
    handleSelectionChange(selectedRows) {
      this.selectedLocksCount = selectedRows ? selectedRows.length : 0;
      this.selectedLockCodes = selectedRows ? selectedRows.map(r => r.lockCode) : [];
    },
    // 批量操作
    batchOperate(type) {
      if (!this.hasSelectedLocks) {
        this.$message.warning("请先选择要操作的车锁");
        return;
      }
      if (this.$refs.listRef && typeof this.$refs.listRef.batchOperate === "function") {
        this.$refs.listRef.batchOperate(type, this.selectedLockCodes);
      }
    },
    // 接收分页数据
    receivePaginationData(v1, v2) {
      if (this.$refs.listRef) {
        this.$refs.listRef.receivePaginationData(v1, v2);
      }
    },
    // 打开运营模式设置对话框
    openOperationModeDialog() {
      if (!this.hasSelectedLocks) {
        this.$message.warning("请先选择要设置运营模式的车锁");
        return;
      }
      this.operationModeForm.mode = "";
      this.operationModeDialogVisible = true;
    },
    // 保存运营模式
    saveOperationMode() {
      if (!this.operationModeForm.mode) {
        this.$message.warning("请选择运营模式");
        return;
      }
      // TODO: 调用API保存运营模式设置
      // 这里需要根据实际API接口进行实现
      this.$message.success("运营模式设置成功");
      this.operationModeDialogVisible = false;
    },
    // 跳转到告警事件页面
    goToAlarmEvent() {
      this.$router.push({
        path: "/main/equipment/alarm",
        query: {
          tab: 'lock' // 默认显示地锁报警标签页
        }
      });
    },
    // 获取未处理的告警事件数量
    async getUnprocessedAlarmCount() {
      try {
        // 测试数据：暂时使用固定值
        this.unprocessedAlarmCount = 5; // 测试数据：5条未处理告警
        
        // 实际API调用（暂时注释）
        // const res = await this.$get(equipWarn(), {
        //   limit: 1,
        //   page: 1,
        //   isHandle: 'n', // 未处理
        // });
        // if (res && res.status === 200) {
        //   this.unprocessedAlarmCount = res.data?.total || 0;
        // } else {
        //   this.unprocessedAlarmCount = 0;
        // }
      } catch (error) {
        console.error("获取未处理告警数量失败:", error);
        this.unprocessedAlarmCount = 0;
      }
    },
    // 获取统计卡片数据
    async fetchStats() {
      // 接口: /api/parking/nb4gLock/analysis
      // 返回字段说明:
      //   totalCount        - 总设备数量
      //   onlineCount       - 在线设备个数
      //   onlinePercent     - 在线设备比例
      //   offlineCount      - 离线设备个数
      //   offlinePercent    - 离线设备比例
      //   floodedCount      - 水淹设备个数
      //   floodedPercent    - 水淹设备比例
      //   lowBatteryCount   - 低电设备个数(<10%)
      //   lowBatteryPercent - 低电量设备比例
      //   baffleErrCount    - 挡板异常的个数
      //   baffleErrPercent  - 挡板异常的比例
      //   baffleRaiseCount  - 车锁升起的个数
      //   baffleRaisePercent- 车锁升起的比例
      try {
        const res = await this.$get("/api/parking/nb4gLock/analysis");
        if (res && res.status === 200 && res.data) {
          const data = res.data;
          this.stats = {
            totalDevice: data.totalCount || 0,
            offlineDevice: data.offlineCount || 0,
            offlineRate: data.offlinePercent || 0,
            onlineDevice: data.onlineCount || 0,
            onlineRate: data.onlinePercent || 0,
            floodDevice: data.floodedCount || 0,
            floodRate: data.floodedPercent || 0,
            lowPowerDevice: data.lowBatteryCount || 0,
            lowPowerRate: data.lowBatteryPercent || 0,
            baffleAbnormal: data.baffleErrCount || 0,
            baffleAbnormalRate: data.baffleErrPercent || 0,
            baffleRising: data.baffleRaiseCount || 0,
            baffleRisingRate: data.baffleRaisePercent || 0,
          };
        }
      } catch (error) {
        console.error("获取统计卡片数据失败:", error);
      }
    },
  },
  mounted() {
    // 获取未处理告警数量
    this.getUnprocessedAlarmCount();
    // 获取统计卡片数据
    this.fetchStats();
    // 每30秒刷新一次未处理告警数量
    this.alarmCountTimer = setInterval(() => {
      this.getUnprocessedAlarmCount();
    }, 30000);
  },
  beforeDestroy() {
    // 清除定时器
    if (this.alarmCountTimer) {
      clearInterval(this.alarmCountTimer);
    }
  },
  watch: {
    // 道路变化不再自动触发查询，改为点击"查询"按钮时触发
  },
};
</script>
<style scoped>




 





/* 列表区域：flex 列布局，自动分配空间 */
section.right {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

/* 搜索区域：固定高度，不参与伸缩 */
.searchbox {
  flex-shrink: 0;
}

/* 列表外层 wrapper：占据剩余高度，约束子组件 */
.list-wrapper {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* 分页组件：正常流，固定在列表下方 */
.pagination-wrapper {
  position: static;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 8px 20px;
  background: white;
  border-top: 1px solid #ebeef5;
  border-radius: 0 0 4px 4px;
}

.downloadButton {
  font-weight: bold;
  color: #278cd8;
  cursor: pointer;
}

.mode-description {
  min-height: 60px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
  border: 1px solid #e4e7ed;
}

.description-item {
  color: #606266;
  line-height: 1.8;
  font-size: 14px;
}

.description-item strong {
  color: #303133;
  font-weight: 600;
}

.description-placeholder {
  color: #909399;
  font-size: 14px;
  text-align: center;
  padding: 20px 0;
}

.alarm-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background-color: #F56C6C;
  color: #fff;
  border-radius: 10px;
  min-width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-size: 12px;
  padding: 0 6px;
  box-sizing: border-box;
  font-weight: bold;
  border: 2px solid #fff;
  z-index: 10;
}

/* 适配 order 布局样式 - 与其他页面保持一致 */
.order .searchbox {
  flex-shrink: 0;
}
.order .searchbox form {
  height: auto;
}
.order .searchbox .search-row {
  margin-bottom: 8px;
}
.searchbox .search-row-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.searchbox .search-row-actions .btn {
  white-space: nowrap;
}

/* 搜索栏输入框和选择框宽度一致 */
.searchbox .form-group .form-control {
  width: 140px;
  box-sizing: border-box;
}
.searchbox .form-group .el-select {
  width: 140px;
  box-sizing: border-box;
}
.searchbox .form-group .el-select .el-input,
.searchbox .form-group .el-select .el-input__inner {
  width: 100% !important;
  box-sizing: border-box;
}

/* 覆盖 baselist.css 媒体查询中对 el-input 宽度的强制设置 */
@media (max-width: 1200px) {
  .searchbox .form-group .el-select {
    width: 140px !important;
  }
  .searchbox .form-group .form-control {
    width: 140px !important;
  }
  .searchbox .el-input {
    width: 140px !important;
  }
}
@media (max-width: 992px) {
  .searchbox .form-group .el-select {
    width: 140px !important;
  }
  .searchbox .form-group .form-control {
    width: 140px !important;
  }
  .searchbox .el-input {
    width: 140px !important;
  }
}
@media (max-width: 768px) {
  .searchbox .form-group .el-select {
    width: 120px !important;
  }
  .searchbox .form-group .form-control {
    width: 120px !important;
  }
  .searchbox .el-input {
    width: 120px !important;
  }
}
@media (max-width: 1366px) {
  .searchbox .form-group .form-control {
    width: 120px;
  }
  .searchbox .form-group .el-select {
    width: 120px;
  }
}

/* 批量操作栏：位于统计卡片与列表之间 */
.batch-actions-bar {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  padding: 8px 20px;
  background: #fff;
  border-bottom: 1px solid #ebeef5;
  flex-shrink: 0;
}
.batch-actions-bar .btn {
  white-space: nowrap;
}

/* 批量操作按钮不同背景色 */
.btn-batch-open {
  color: #fff !important;
  background-color: #67c23a !important;
  border-color: #67c23a !important;
}
.btn-batch-open:hover {
  background-color: #85ce61 !important;
  border-color: #85ce61 !important;
}
.btn-batch-close {
  color: #fff !important;
  background-color: #e6a23c !important;
  border-color: #e6a23c !important;
}
.btn-batch-close:hover {
  background-color: #ebb563 !important;
  border-color: #ebb563 !important;
}
.btn-batch-reset {
  color: #fff !important;
  background-color: #409eff !important;
  border-color: #409eff !important;
}
.btn-batch-reset:hover {
  background-color: #66b1ff !important;
  border-color: #66b1ff !important;
}
.btn-batch-restart {
  color: #fff !important;
  background-color: #f56c6c !important;
  border-color: #f56c6c !important;
}
.btn-batch-restart:hover {
  background-color: #f78989 !important;
  border-color: #f78989 !important;
}

/* 统计卡片样式 */
.stats-cards {
  display: flex;
  gap: 16px;
  padding: 16px 20px;
  background: #fff;
  flex-wrap: wrap;
  flex-shrink: 0;
}
.stats-card {
  flex: 1;
  min-width: 200px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
}
.stats-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.stats-icon {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
}
.stats-title {
  font-size: 10px;
  color: #606266;
  white-space: nowrap;
}
.stats-value {
  display: flex;
  align-items: baseline;
  gap: 4px;
}
.stats-main {
  font-size: 24px;
  font-weight: 600;
  color: #303133;
}
.stats-separator {
  font-size: 18px;
  color: #909399;
}
.stats-sub {
  font-size: 16px;
  color: #f56c6c;
  font-weight: 500;
}
.stats-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
@media (max-width: 1440px) {
  .stats-cards {
    gap: 12px;
    padding: 12px 16px;
  }
  .stats-card {
    min-width: 160px;
    padding: 12px 16px;
  }
  .stats-main {
    font-size: 20px;
  }
  .stats-sub {
    font-size: 14px;
  }
}
</style>
<style>
/* .tablelist(父级) 有 overflow:auto，当子内容超出时会产生竖向滚动条。
   .nb-lock-page 设 height:100% + overflow:hidden 确保内容不溢出父级，
   滚动完全由内部 el-table 处理 */
.nb-lock-page {
  height: 100%;
  overflow: hidden;
}
</style>
